import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Eye, Trash2 } from "react-feather";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import { useDeleteCustomerMutation, useGetAllCustomerQuery } from "../../redux/api/userApi";
import Table from "../../pagination/datatable";
import CustomerModal from "./customerModal";
import toast from "react-hot-toast";

const CustomerList = () => {
  const {data: customerResponse, refetch} = useGetAllCustomerQuery();
  const [deleteCustomer] = useDeleteCustomerMutation();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const [deleteCustomerId, setDeleteCustomerId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  console.log("cusomter", customerResponse)

  const handleDeleteCustomer = async () => {
    console.log("Deleting customer with ID:", deleteCustomerId);
    if (!deleteCustomerId) {
      console.error("No customer ID provided for deletion");
      return;
    }
    
    try {
      await deleteCustomer(deleteCustomerId).unwrap();
      toast.success("Customer Deleted Successfully");
      refetch(); // Refresh the customer list
    } catch (error) {
      // console.error("Delete error:", error);
      toast.error(`Unable to delete Customer`);
    } finally {
      setShowDeleteModal(false);
      setDeleteCustomerId(null);
    }
  }
  const openDeleteModal = (id) => {
    setDeleteCustomerId(id);
    setShowDeleteModal(true);
  }

  useEffect(() => {
  const modal = document.getElementById('add-customer');
  if (modal) {
    modal.addEventListener('hidden.bs.modal', () => {
      setSelectedCustomer(null);
      setIsAddMode(true); // Reset to add mode when modal closes
    });
    
    return () => {
      modal.removeEventListener('hidden.bs.modal', () => {});
    };
  }
}, []);
const columns = [
  {
    title: "Customer Code",
    dataIndex: "customerCode",
    sorter: (a, b) => a.customerCode.length - b.customerCode.length,
    responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    sorter: (a, b) => a.customerName.length - b.customerName.length,
    responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
  },
  {
    title: "Phone",
    dataIndex: "phone",
    sorter: (a, b) => a.phone.length - b.phone.length,
    responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
  },
  {
    title: "Email",
    dataIndex: "email",
    sorter: (a, b) => a.email.length - b.email.length,
    responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
  },
  {
    title: "Current Balance",
    dataIndex: "currentBalance",
    sorter: (a, b) => a.currentBalance - b.currentBalance, // Changed to numeric comparison
     render: (val) => {
    if (val === null || val === undefined) return 'N/A';
    return '₹' + Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
    responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
  },
  {
    title: "Address",
    dataIndex: "address",
    responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
  },
  {
    title: "Action",
    dataIndex: "action",
    render: (_, record) => (
      <div className="action-table-data">
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Link
            className="me-2 p-2"
            to="#"
            data-bs-toggle="modal" 
            data-bs-target="#add-customer"
            onClick={() => {
              setSelectedCustomer(record);
              setIsAddMode(false);     
            }}
          >
            <Edit className="feather-edit" />
          </Link>
          <Link
            className="confirm-text p-2"
            onClick={(e) => {
              e.preventDefault();
              openDeleteModal(record._id);
            }}
          >
            <Trash2 className="feather-trash-2" />
          </Link>
        </div>
      </div>
    ),
    responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
  },
];

const expandable = {
  expandedRowRender: (record) => (
      <div style={{ padding: '10px' }}>
          <p><strong>Customer Code:</strong> {record.customerCode || "-"}</p>
          <p><strong>Phone:</strong> {record.phone || "-"}</p>
          <p><strong>Email:</strong> {record.email || "-"}</p>
          <p><strong>Credit Limit:</strong> {record.creditLimit?.toFixed(2) || "-"}</p>
          <p><strong>Address:</strong> {record.address || "-"}</p>
      </div>
  ),
  rowExpandable: (record) => true,
  expandRowByClick: true,
};
const excelOptions = {
  fileName: 'Customer_List',
  sheetName: 'Customers',
  columns: [
    { key: 'customerCode', header: 'Customer Code' },
    { key: 'customerName', header: 'Customer Name' },
    { key: 'phone', header: 'Phone' },
    { key: 'email', header: 'Email' },
    { key: 'currentBalance', header: 'Current Balance' },
    { key: 'address', header: 'Address' },
    { key: 'creditLimit', header: 'Credit Limit' }
  ],
  data: customerResponse?.map(customer => ({
    customerCode: customer.customerCode,
    customerName: customer.customerName,
    phone: customer.phone,
    email: customer.email,
    currentBalance: customer.currentBalance?.toFixed(2),
    address: customer.address,
    creditLimit: customer.creditLimit?.toFixed(2)
  })) || []
};

const pdfOptions = {
  fileName: 'Customer_List',
  title: 'Customer List',
  columns: [
    { key: 'customerCode', header: 'Customer Code' },
    { key: 'customerName', header: 'Customer Name' },
    { key: 'phone', header: 'Phone' },
    { key: 'email', header: 'Email' },
    { key: 'currentBalance', header: 'Current Balance' },
    { key: 'address', header: 'Address' },
    { key: 'creditLimit', header: 'Credit Limit' }
  ],
  data: customerResponse?.map(customer => ({
    customerCode: customer.customerCode,
    customerName: customer.customerName,
    phone: customer.phone,
    email: customer.email,
    currentBalance: customer.currentBalance?.toFixed(2),
    address: customer.address,
    creditLimit: customer.creditLimit?.toFixed(2)
  })) || [],
  fileNamePrefix: 'Customers'
};

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>CustomerList</h4>
                <h6>Manage your CustomerList</h6>
              </div>
            </div>
            <ul className="table-top-head">
            <TooltipIcons excelOptions={excelOptions} pdfOptions={pdfOptions}/>
              <RefreshIcon />
              <CollapesIcon />

            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-customer"
                onClick={() => {
                  setSelectedCustomer(null); // Clear selection
                  setIsAddMode(true);       // Set to add mode
                }}
              >
              <i className='ti ti-circle-plus me-1'></i>
                Add Customer
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
              </div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                     Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        New Joiners
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <Table
                  className="table datanew"
                  columns={columns}
                  dataSource={customerResponse}
                  key={customerResponse?._id}
                  expandable={expandable}
                  // rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

            <CustomerModal
        isEdit={!isAddMode}          // true=edit, false=add
        customerData={selectedCustomer} // null=add, object=edit
        onSuccess={() => {
          // Refresh data after success
          // alert(isAddMode ? "Customer created!" : "Customer updated!");
          // setSelectedCustomer(null);
          refetch(); // Refresh the customer list
        }}
      />
       {/* <CustomerModal/> */}
       


       {showDeleteModal && (
        <div className="modal fade show" id="delete-modal" style={{display: 'block'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-5">
              <div className="modal-body text-center p-0">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  Delete Customer
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  Are you sure you want to delete this customer?
                </p>
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleDeleteCustomer}
                  >
                    Yes Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default CustomerList;
